module.exports = __webpack_public_path__ + "static/media/Arial-ItalicMT.20870716.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Arial-ItalicMT.ttf
// module id = 14
// module chunks = 0